exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".CJeUdNc0tjE6-cyVIm_bR{margin:0 0 20px 0;position:relative}.CJeUdNc0tjE6-cyVIm_bR ._1dm0aw8PcWwcEL4WAM2dPQ{border-bottom:1px solid #e0e0e0;padding-top:5px;padding-bottom:5px;margin:15px 0 0 0}.CJeUdNc0tjE6-cyVIm_bR .cg3UvNa0ZHnIkUwa0UiN3{padding-left:15px;padding-right:15px}.CJeUdNc0tjE6-cyVIm_bR ._2Ls4MVcdTNh7hzyzuPHiJ1{margin:0 0}.CJeUdNc0tjE6-cyVIm_bR ._19juBXLGmuGIQdN_8oOqrY{padding:10px 0 0 0}.CJeUdNc0tjE6-cyVIm_bR ._2G0RAtfTLsCTvpZFbqD9_V{padding:0 15px;font-size:13px;font-weight:500}\n", ""]);

// Exports
exports.locals = {
	"ResultsGroup": "CJeUdNc0tjE6-cyVIm_bR",
	"heading": "_1dm0aw8PcWwcEL4WAM2dPQ",
	"leftRightPadding": "cg3UvNa0ZHnIkUwa0UiN3",
	"sectionTitle": "_2Ls4MVcdTNh7hzyzuPHiJ1",
	"sectionContent": "_19juBXLGmuGIQdN_8oOqrY",
	"sectionFooter": "_2G0RAtfTLsCTvpZFbqD9_V"
};